import styled from "@emotion/styled";
import React from "react";
import UI from "@mile-meeting/mile-ui";

type TimeLabelListProps = {
  scrollOffset: number;
};
const TimeLabelList: React.FC<TimeLabelListProps> = ({ scrollOffset }) => {
  const time = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

  return (
    <TimeLabelListWrapper>
      <Container style={{ transform: `translateY(-${scrollOffset}px)` }}>
        {time.map((hour, index) => (
          <UI.Typography
            key={index}
            type="caption01"
            fontStyle="bold"
            color="var(--alias-color-label-alternative)"
            style={{ marginLeft: "17px" }}
          >
            {hour.toString().padStart(2, "0")}:00
          </UI.Typography>
        ))}
      </Container>
    </TimeLabelListWrapper>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  transform: translateY(0);
`;

const TimeLabelListWrapper = styled.div`
  position: absolute;
  top: 312px;
  height: calc(100vh - 332px);
  overflow: hidden;
  pointer-events: none;
`;

export default React.memo(TimeLabelList);
